import React, { Component, Fragment } from "react";
import "./certificate.css";
import Auth from "../../services/authService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import { toast } from "react-toastify";
import UserCertificatesService from "../../services/userCertificatesService";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Modal from 'react-bootstrap/Modal';
import SendCertificate from "./sendCertificate"

const user = Auth.getCurrentUser();

export default class certificate extends Component {

    state = {
        isLoading: false,
        UserCertificatesItems: [],
        certificatesItemsCount: 0,
        showModal: false,
        certificateNo: ""
    };

    async componentDidMount() {
        if (Auth.getCurrentUser()) {
            try {
                const result =
                    await UserCertificatesService.getCustomerCertificatesItems(
                        user.customerid
                    );
                this.setState({ UserCertificatesItems: result.data });
                this.setState({ certificatesItemsCount: result.data.length });
                const isLoading = true;
                this.setState({ isLoading });
            } catch (ex) {
                if (ex.code !== "ERR_NETWORK" && ex.code !== "ERR_BAD_REQUEST") {
                    toast.error(ex.response.data.Message);
                }
            }
        }
    }


    handleShowModal = async (certificateNo) => {
        if (certificateNo) {
            this.setState({ showModal: true }, () => {

            });
            this.setState({ certificateNo: certificateNo }, () => {

            });
        }
    };

    render() {
        return (
            <Page>
                <Header />
                <section className="container">
                    <div className="row hrow">
                        {this.state.isLoading ? (
                            <section className="innerSection">
                                {this.state.certificatesItemsCount == "0" &&
                                    <section className="container">
                                        <div className="hrh_resultNotFound">
                                            <span>گواهینامه ای برای نمایش وجود ندارد</span>
                                        </div>
                                    </section>
                                }
                                {this.state.UserCertificatesItems.map((item) => (
                                    <section>
                                        {/*<div className="certificateitemout" key={"certificateitemout"+item.id}>*/}
                                            <div className="productitme" key={"productitme"+item.id}>
                                                <div className="DeviceTypeIcon D05" key={"DeviceTypeIcon" + item.id}></div>
                                                <h3 className="DeviceName" key={"DeviceName" + item.id}>نام دوره : {item.courseFieldTitle} </h3>
                                                <h3 className="DeviceType" key={"DeviceType" + item.id}> {item.courseFieldTitleInLatin}</h3>
                                                <span>نام شرکت کننده : {item.fullname} {item.fullnameEn}</span>
                                            </div>
                                            {/*<div className="row hrow">*/}
                                            {/*    <button onClick={(e) => { this.handleShowModal( item.certificateNo) }} className="DevicesDoc">*/}
                                            {/*        دریافت گواهی نامه*/}
                                            {/*    </button>*/}
                                            {/*</div>*/}
                                        {/*</div>*/}
                                    </section>
                                ))}
                            </section>) : (<LoadingSpinner />)}
                    </div>
                    <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}  >
                        <Modal.Header closeButton className="modal-header nav-icon3" >
                            <h6>لطفا آدرس ایمیل دریافت کننده گواهینامه را وارد نمایید</h6>
                        </Modal.Header>
                        <Modal.Body className="offcanvas-body d-flex align-content-between flex-wrap">
                            <SendCertificate certificateNo={this.state.certificateNo} />
                        </Modal.Body>
                    </Modal>
                </section>
                <Footer />
            </Page>
        );
    }
}
